// extracted by extract-css-chunks-webpack-plugin
module.exports = {"areaChartLabel":"areaChartLabel-1tkB4","left":"left-24RNu","right":"right-1uNJI","legend":"legend-Qa5CK","areaChartTooltipLabel":"areaChartTooltipLabel-3R0XK"};